import { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

import styles from "./style.module.scss";
import LeftSideComponent from "./leftSideComponent";
import SettingsTabs from "./settingsTabs";
import ProfileTabs from "./profilTabs";
import profileActions from '../../redux/profile/actions'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  text: {
    top: "50px",
    position: "relative",
    left: "-50px",
  },
  cover: {
    width: 73,
    height: 73,
    borderRadius: "50%",
  },
}));

const Profile = () => {
  const classes = useStyles();
  const [selected, setSelected] = useState("account");
  const dispatch = useDispatch()

  const { loading } = useSelector((state) => ({
    loading: state.settings.loading || state.profile.loading,
  }));
  useEffect(() => {
    dispatch({
      type: profileActions.GET_USER_MUSICS,
    });
  }, []);
  return (
    <div className={styles.mainComponent}>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
      </Backdrop>
      <div className={styles.mainContent}>
          <div className={styles.leftContainer}>
            <LeftSideComponent selected={selected} setSelected={setSelected} />
          </div>
          <div className={styles.rightContainer}>
            {selected === "account" && <SettingsTabs />}
            {selected === "profile" && <ProfileTabs />}
          </div>
          <div style={{width: 247}} />
        </div>
    </div>
  );
};

Profile.propTypes = {};

export default withRouter(Profile);
